// src/utils/nomi.js
//
// Il cognome è un dato sensibile: non va mai mostrato ad altri utenti né salvato
// nei documenti che altri leggono (richieste, chat, recensioni). Compare solo nelle
// pagine in cui la persona vede/modifica i propri dati.

// Primo nome da un campo che può contenere nome e cognome insieme
// (es. displayName di Google, o il vecchio nome_destinatario "Mario Rossi").
export const soloNome = (testo, fallback = "") =>
    String(testo || "").trim().split(/\s+/)[0] || fallback;
